import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, Optional } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthModuleConfig, OAuthService } from "angular-oauth2-oidc";
import jwtDecode from "jwt-decode";
import {
  BehaviorSubject,
  combineLatest,
  Observable,
  ReplaySubject,
} from "rxjs";
import { filter, map, tap } from "rxjs/operators";
import { getBackHost } from "../util/server-util";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private readonly isAuthenticatedSubject$ = new BehaviorSubject<boolean>(false);
  public isAuthenticated$ = this.isAuthenticatedSubject$.asObservable();

  private readonly isDoneLoadingSubject$ = new ReplaySubject<boolean>();
  public isDoneLoading$ = this.isDoneLoadingSubject$.asObservable();

  public canActivateProtectedRoutes$: Observable<boolean> = combineLatest([
    this.isAuthenticated$,
    this.isDoneLoading$,
  ]).pipe(map((values) => values.every((b) => b)));

  constructor(
    private readonly http: HttpClient,
    private readonly  oauthService: OAuthService,
    private readonly router: Router,
    @Optional() private readonly moduleConfig: OAuthModuleConfig
  ) {
    this.oauthService.events.subscribe((_) => {
      this.isAuthenticatedSubject$.next(
        this.oauthService.hasValidAccessToken()
      );
    });

    this.oauthService.events
      .pipe(
        filter(e => ['session_terminated', 'session_error', 'token_refresh_error'].includes(e.type))
      )
      .subscribe(_ => {
        this.logout();
      });

    this.http
      .get<any>(getBackHost("../../ui/security.json"))
      .subscribe((data) => {
        this.moduleConfig.resourceServer.allowedUrls.push(data.issuer);

        this.oauthService.configure({
          issuer: data.issuer,
          redirectUri: window.location.origin + "/enquadramento/ui/home",
          clientId: data.clientId,
          responseType: "code",
          requireHttps: false,
          scope: data.scopes,
        });

        this.oauthService
          .loadDiscoveryDocumentAndLogin()
          .then(() => {
            const _token = jwtDecode(this.oauthService.getAccessToken());
            localStorage.setItem('username', _token['preferred_username']);
            this.isDoneLoadingSubject$.next(true);
          })
          .catch(() => {
            this.isDoneLoadingSubject$.next(true);
          });
        this.oauthService.setupAutomaticSilentRefresh();
      });
  }

  isAutenticado() {
    return this.oauthService.hasValidAccessToken();
  }

  logout() {
    this.oauthService.logOut();
  }
}
